import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { UserCheck, Clock } from 'lucide-react';

export default function WelcomeScreen(): React.ReactElement {
    const { userName, logout } = useAuth();

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
            <div className="max-w-md w-full bg-white rounded-lg shadow-xl p-8">
                <div className="text-center mb-6">
                    <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <UserCheck className="text-blue-600" size={40} />
                    </div>
                    <h1 className="text-2xl font-bold text-gray-800 mb-2">
                        Bienvenue, {userName}!
                    </h1>
                    <p className="text-gray-600">
                        Votre compte a été créé avec succès
                    </p>
                </div>

                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
                    <div className="flex items-start space-x-3">
                        <Clock className="text-yellow-600 flex-shrink-0 mt-1" size={20} />
                        <div>
                            <h3 className="font-semibold text-yellow-800 mb-1">
                                En attente d'activation
                            </h3>
                            <p className="text-sm text-yellow-700">
                                Un administrateur doit vous assigner un rôle pour que vous puissiez accéder à l'application.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="space-y-3 text-sm text-gray-600">
                    <p><strong>Prochaines étapes:</strong></p>
                    <ul className="list-disc list-inside space-y-1 ml-2">
                        <li>Un administrateur va vous assigner un rôle</li>
                        <li>Vous recevrez les permissions appropriées</li>
                        <li>Vous pourrez ensuite accéder à l'application</li>
                    </ul>
                </div>

                <div className="mt-8 pt-6 border-t">
                    <button
                        onClick={logout}
                        className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-2 px-4 rounded-lg transition-colors"
                    >
                        Déconnexion
                    </button>
                </div>
            </div>
        </div>
    );
}
